import { Select } from 'antd';
import { useEffect, useState, type CSSProperties } from 'react';

import {
  useClientsGetClient,
  useClientsListClients,
} from '@/api/generated/endpoints/clients/clients';

const DEBOUNCE_MS = 250;

/** Выбор клиента с поиском по названию, сети и началу ИНН. */
export function ClientSelect({
  value,
  onChange,
  placeholder,
  style,
  id,
}: {
  value: number | null;
  onChange: (clientId: number | null) => void;
  placeholder?: string;
  style?: CSSProperties;
  /** Form.Item передаёт id — по нему <label> связан с полем. */
  id?: string;
}) {
  const [text, setText] = useState('');
  const [query, setQuery] = useState('');
  useEffect(() => {
    const t = setTimeout(() => {
      setQuery(text.trim());
    }, DEBOUNCE_MS);
    return () => {
      clearTimeout(t);
    };
  }, [text]);

  const list = useClientsListClients({ q: query || null, status: 'all', limit: 20 });
  // Выбранный клиент мог не попасть в первые 20 — подтянуть его название.
  const selected = useClientsGetClient(value ?? 0, { query: { enabled: value !== null } });
  const options = (list.data?.items ?? []).map((c) => ({
    value: c.id,
    label: c.brand ? `${c.brand} · ${c.name}` : c.name,
  }));
  if (selected.data && !options.some((o) => o.value === selected.data.id)) {
    const c = selected.data;
    options.unshift({ value: c.id, label: c.brand ? `${c.brand} · ${c.name}` : c.name });
  }

  return (
    <Select<number>
      showSearch
      allowClear
      filterOption={false}
      value={value}
      {...(placeholder === undefined ? {} : { placeholder })}
      {...(style === undefined ? {} : { style })}
      {...(id === undefined ? {} : { id })}
      loading={list.isFetching}
      onSearch={setText}
      onChange={(id: number | undefined) => {
        onChange(id ?? null);
      }}
      options={options}
    />
  );
}
